import { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@interstate/components/AccordionGroup';
import { Typography } from '@interstate/components/Typography';
import { CurrentAddress } from './CurrentAddress';
import { AdditionalIncome } from './AdditionalIncome';
import { PreviousAddress } from './PreviousAddress';
import { CurrentEmployment } from './CurrentEmployment';
import { PreviousEmployment } from './PreviousEmployment';
import { useCustomerCardContext } from '../CustomerCardProvider';

export const HousingAndEmploymentInfo = () => {
    const { hasHousingAndEmploymentData } = useCustomerCardContext();
    const [expanded, setExpanded] = useState(hasHousingAndEmploymentData);

    const handleChange = () => {
        setExpanded(!expanded);
    };

    return (
        <Accordion expanded={expanded} onChange={handleChange} data-testid="housing-employment-accordion" sx={{ border: 'none' }}>
            <AccordionSummary chevronPosition="left">
                <Typography
                    variant="anchor-block-md"
                    color="base.color.blue.700"
                    data-testid="housing-employment-accordion-header"
                    sx={{ textWrap: 'auto' }}
                >
                    Housing & Employment Information
                </Typography>
            </AccordionSummary>
            <AccordionDetails data-testid="housing-employment-accordion-content">
                <CurrentAddress />
                <PreviousAddress />
                <CurrentEmployment />
                <PreviousEmployment />
                <AdditionalIncome />
            </AccordionDetails>
        </Accordion>
    );
};
